import { render } from "./TextBlockWithImagePreview.vue?vue&type=template&id=0ede20ea"
import script from "./TextBlockWithImagePreview.vue?vue&type=script&lang=js"
export * from "./TextBlockWithImagePreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__